export default __webpack_public_path__ + "static/media/icon-home-delete.0ac2d232.svg";